import { Directive, ElementRef, inject, OnDestroy, OnInit, output } from '@angular/core';

const clickOutsideEvents = ['mouseup', 'touchend'];
const isDescendant = (el, target) => target !== null ? el === target || isDescendant(el, target.parentNode) : false;


@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[clickOutside]',
	standalone: true
})
export class ClickOutsideDirective implements OnInit, OnDestroy {
	el = inject(ElementRef);

	readonly clickOutside = output<any>();

	public onClickOutsideHandler: EventListener;

	constructor() {
		this.onClickOutsideHandler = this.handleClickOutside.bind(this);
	}

	ngOnInit() {
		clickOutsideEvents.forEach((e) => {
			document.addEventListener(e, this.onClickOutsideHandler);
		});
	}

	ngOnDestroy() {
		clickOutsideEvents.forEach((e) => {
			document.removeEventListener(e, this.onClickOutsideHandler);
		});
	}

	handleClickOutside(event) {
		if (
			document.documentElement.contains(event.target) &&
			!isDescendant(this.el.nativeElement, event.target)
		) {
			this.clickOutside.emit(event);
		}
	}
}
